import { reportsSalesFunnelListOptions, SalesFunnelReport } from '@crm/api'
import { getColor } from '@crm/components/Charts/utils'
import { TableContainer } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'

import { useQuery } from '@tanstack/react-query'
import { Space } from 'antd'
import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { useStyles } from '../styles'

import type { TableColumnsType } from 'antd'

export const SalesFunnelTable = () => {
  const { t } = useLocales()
  const { params } = useQueryUpdate()
  const { styles } = useStyles()

  const { data, isLoading } = useQuery(
    reportsSalesFunnelListOptions({
      query: params
    })
  )

  const columns: TableColumnsType<{
    label: string
    conversion_leads: number
    leads_count: number
    color: string
  }> = useMemo(
    () => [
      {
        title: t('sales_funnel_report.lead_source'),
        render: ({ color, label }) => (
          <Space size="small">
            <div className={styles.listBullet} style={{ background: color }} />
            {label}
          </Space>
        )
      },
      {
        title: t('sales_funnel_report.lead_nr'),
        dataIndex: 'leads_count'
      },
      {
        title: t('sales_funnel_report.conversion_rate'),
        render: ({ conversion_leads }) => `${conversion_leads} %`
      }
    ],
    [t]
  )

  const tableData = useMemo(() => {
    return data?.map((item: SalesFunnelReport, key: number) => ({
      label: item.name || '',
      conversion_leads: item.conversion_rate || 0,
      leads_count: item.count || 0,
      color: getColor(key)
    }))
  }, [data])

  return (
    <TableContainer
      rowKey={() => uuidv4()}
      data={{ results: tableData, count: tableData?.length }}
      loading={isLoading}
      scroll={{ x: 'max-content' }}
      showSearch={false}
      columns={columns}
      pagination={false}
      showSorterTooltip={false}
    />
  )
}
